module.exports = __webpack_public_path__ + "static/media/pending-tests-right-arrow.f71f0104.svg";